module.exports = __webpack_public_path__ + "static/media/save.a1e5369c.svg";